import { verifyAndCheckAppliedCarouselCoupons, updateSelectAllCouponsInput } from "../../components/loyaltyUtils";
import { initJQueryCoupons } from "./couponsCarouselJQuery";
import { setAllCachedCoupons } from "./CouponsCarouselComponentJQuery";
import { cartaoContinenteErrorHTML } from "./couponsComponents";
import { updateCartSummaryModalClass } from "../../components/cartUtil";

/**
 * @function
 * @description - Initialize coupons from cart events
 */
const getMessageAndShowRemovalConfirmModal = () => {
    const $removeModal = $("#remove-coupon-modal");
    const $messageContainer = $removeModal.find(".js-remove-coupon-msg");
    const url = $messageContainer.data("url");

    if ($messageContainer.html() != "") {
        $removeModal.modal("show");
        updateCartSummaryModalClass(true);
    } else {
        $.spinner().start();
        $.ajax({
            url: url,
            method: "GET",
            dataType: "html",
            success: data => {
                $messageContainer.html(data);
                $removeModal.modal("show");
                updateCartSummaryModalClass(true);                
                //GTM logic - Start
                document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                    detail: {
                        "success": true,
                        "messageContent": data,
                    }
                }));
                //GTM logic - End
                $.spinner().stop();
            },
            error: () => {
                $.spinner().stop();
            }
        });
    }
};

/**
 * @function
 * @description - Get customer coupons(benefits) and displayed in the carousel
 */
const getCustomerCarouselCoupons = async () => {
    const customerBenefitsURL = $(".js-customer-benefits").attr("data-url");
    const appliedCoupons = $(".js-loyalty-coupons").attr("data-applied-coupons");

    const appliedCouponsObj = appliedCoupons ? JSON.parse(appliedCoupons) : {};

    const allLoyaltyAppliedCoupons = appliedCouponsObj.gifts.concat(appliedCouponsObj.vouchers);

    if (!customerBenefitsURL) { return; }

    const $couponsCarouselContainer = $(".js-cart-coupons-carousel-ref");
    const $couponsErrorMessage = $(".js-get-benefits-service-error");

    if ($couponsCarouselContainer.length === 0) { return; }

    try {
        const response = await fetch(customerBenefitsURL);

        if (response.ok) {
            const result = await response.json();
            const hasResponseDataAndCoupons = () => {
                return result && result.data && !result.error && ((result.data.vouchers && Object.keys(result.data.vouchers).length) || (result.data.gifts && Object.keys(result.data.gifts).length));
            };

            if (hasResponseDataAndCoupons()) {
                // SET IN CACHE ALL COUPONS
                let allCachedCoupons = [], auxArray = [];
                allCachedCoupons = allCachedCoupons.concat(result.data.vouchers, result.data.gifts);
                for (let index = 0; index < allCachedCoupons.length; index++) {
                    const element = allCachedCoupons[index];
                    const couponInfo = {
                        id: element.voucherId || element.giftId,
                        description: element.message,
                        amount: element.value,
                        unit: element.unit,
                        isCarouselCoupon: true
                    };
                    auxArray.push(couponInfo);
                }

                //save all coupons in cache
                setAllCachedCoupons(auxArray);

                // init carousel
                initJQueryCoupons(".js-cart-coupons-carousel-ref", result);

                if (allLoyaltyAppliedCoupons) {
                    verifyAndCheckAppliedCarouselCoupons(allLoyaltyAppliedCoupons);
                }

                hideAppliedCarouselCoupons();
            } else {
                $(".coupons-carousel-container").addClass("d-none");
                $couponsErrorMessage.append(cartaoContinenteErrorHTML(result)).removeClass("d-none");
            }
        } else {
            $(".coupons-carousel-container").addClass("d-none");
            $couponsErrorMessage.append(cartaoContinenteErrorHTML()).removeClass("d-none");
        }
    } catch (error) {
        $(".coupons-carousel-container").addClass("d-none");
        $couponsErrorMessage.append(cartaoContinenteErrorHTML()).removeClass("d-none");
    }
};

/**
 * @function
 * @description - Initialize coupons from cart events
 */
const initCartCouponsEvents = () => {
    $("#remove-coupon-modal").on("hidden.bs.modal", () => {
        updateSelectAllCouponsInput();
    });
};

/**
 * @function
 * @description - hides the carousel coupons from the applied coupons
 */
const hideAppliedCarouselCoupons = () => {
    const carouselCoupons = [...document.querySelectorAll(".coupon-carousel-input")].map(carouselCouponInput => {
        if (carouselCouponInput.closest(".slick-slide").classList.contains("slick-cloned")) {
            return null;
        }

        return carouselCouponInput.value;
    }).filter(carouselCouponInput => {

        return !!carouselCouponInput;
    });

    const appliedCoupons = [...document.querySelectorAll(".js-loyalty-coupon-area")].map(appliedCouponWrapper => {

        return appliedCouponWrapper?.dataset?.uuid;
    });

    appliedCoupons.forEach(appliedCoupon => {
        if (carouselCoupons.indexOf(appliedCoupon) > -1) {
            $(`.js-loyalty-coupon-area.coupon-uuid-${appliedCoupon}`).addClass("d-none");
        }
    });

    const filteredAppliedCoupons = [...document.querySelectorAll(".js-loyalty-coupon-area:not(.d-none)")];

    if (!filteredAppliedCoupons[0]) { return; }
    filteredAppliedCoupons[0].classList.add("mt-0"); //removes margin-top from the first coupon
};

export { getCustomerCarouselCoupons, initCartCouponsEvents, getMessageAndShowRemovalConfirmModal };
